import { openBlock as n, createElementBlock as l, mergeProps as d, createCommentVNode as s, createElementVNode as i, renderSlot as r } from "vue";
import { _ as c } from "../_plugin-vue_export-helper-dad06003.js";
import { w as f } from "../util-b2b0dc25.js";
const m = {
  name: "rButton2",
  props: {
    /**
     * 尺寸: large | medium
     */
    size: {
      type: String,
      default: "medium"
    },
    /**
     * 颜色类型：default | primary | success | warning | error
     */
    type: {
      type: String,
      default: "default"
    },
    /**
     * 是否存在链接地址，使用html的a标签
     * 当存在link标签时，则使用href属性
     */
    link: {
      type: String,
      default: void 0
    },
    /**
     * 是否为朴素按钮
     */
    plain: {
      type: Boolean,
      default: !1
    },
    /**
     * 是否为纯文字按钮
     */
    text: {
      type: Boolean,
      default: !1
    },
    /**
     * 是否椭圆按钮
     */
    round: {
      type: Boolean,
      default: !1
    },
    /**
     * 是否圆形按钮
     */
    circle: {
      type: Boolean,
      default: !1
    },
    /**
     * 是否增加下划线
     */
    underline: {
      type: Boolean,
      default: !1
    },
    /**
     * 是否字体加粗
     */
    bold: {
      type: Boolean,
      default: !1
    },
    /**
     * 点击操作是否显示加载中状态
     * 1. 开启后，可以防止连点
     * 2. 开启后，任何点击都会出现加载中的提示，需要主动关闭，会为上级组件暴露一个done函数（如果上级组件也有自定义入参时，需要通过$event变量来标志该button组件的done回调），调用以使关闭
     * 3. 开启后，点击且未主动关闭时，会在10s后自动取消加载中状态
     */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
     * 禁用
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * 原生type的类型: button | submit | reset
     */
    nativeType: {
      type: String,
      default: "button"
    },
    /**
     * 是否默认阻止默认行为 prevent
     */
    prevent: {
      type: Boolean,
      default: !0
    }
  },
  emits: {
    /**
     * 点击事件，会阻止向上冒泡
     */
    click: null
  },
  data() {
    return {
      isLoading: !1,
      timeoutID: null
    };
  },
  methods: {
    onClick(e) {
      this.prevent && e.preventDefault(), !(this.isLoading || this.disabled) && (this.loading && (clearTimeout(this.timeoutID), this.isLoading = !0, this.timeoutID = setTimeout(() => {
        this.isLoading = !1;
      }, 10 * 1e3)), this.$emit("click", () => {
        clearTimeout(this.timeoutID), setTimeout(() => {
          this.isLoading = !1;
        }, 200);
      }));
    }
  }
}, y = ["href"], h = {
  key: 0,
  class: "r-button2-loading"
}, _ = /* @__PURE__ */ i(
  "i",
  { class: "el-icon-loading" },
  null,
  -1
  /* HOISTED */
), g = [
  _
], k = ["native-type"], B = {
  key: 0,
  class: "r-button2-loading"
}, v = /* @__PURE__ */ i(
  "i",
  { class: "el-icon-loading" },
  null,
  -1
  /* HOISTED */
), L = [
  v
];
function D(e, o, t, C, a, u) {
  return t.link && !t.disabled ? (n(), l("a", d({
    key: 0,
    class: {
      "r-button2": !0,
      "r-button2-link": !0,
      [`r-button2-${t.type}`]: t.type,
      [`r-button2-${t.size}`]: !0,
      "r-button2-enabled": !t.disabled,
      "r-button2-disabled": t.disabled,
      "r-button2-round": t.round,
      "r-button2-circle": t.circle,
      "r-button2-bold": t.bold,
      "r-button2-underline": t.underline,
      "r-button2-plain": t.plain,
      "r-button2-text": t.text
    },
    href: t.link
  }, e.$attrs), [
    a.isLoading ? (n(), l("span", h, g)) : s("v-if", !0),
    i("span", null, [
      r(e.$slots, "default")
    ])
  ], 16, y)) : (n(), l("button", d({
    key: 1,
    class: {
      "r-button2": !0,
      [`r-button2-${t.type}`]: t.type,
      [`r-button2-${t.size}`]: !0,
      "r-button2-enabled": !t.disabled,
      "r-button2-disabled": t.disabled,
      "r-button2-round": t.round,
      "r-button2-circle": t.circle,
      "r-button2-bold": t.bold,
      "r-button2-underline": t.underline,
      "r-button2-plain": t.plain,
      "r-button2-text": t.text
    },
    "native-type": t.nativeType
  }, e.$attrs, {
    onClick: o[0] || (o[0] = (...b) => u.onClick && u.onClick(...b))
  }), [
    a.isLoading ? (n(), l("span", B, L)) : s("v-if", !0),
    i("span", null, [
      r(e.$slots, "default")
    ])
  ], 16, k));
}
const T = /* @__PURE__ */ c(m, [["render", D], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/button2/button2.vue"]]), z = f(T);
export {
  z as default
};
